import Markdown from "markdown-to-jsx";
import Image from 'next/image'
import styles from "./proprietyLocation.module.css";


export default function ProprietyLocation({ data }) {
  return (
    <>
      <section className={styles.container}>
        <img className={styles.place} src="/icons/bg-style.png" width={389} height={34} />
        <div className={styles.content}>
          <div className={styles.LocationDesc}>
            <div className={styles.description}>
              <div className={styles.title}>
                <div className={styles.parallelogramDetail} />
                <h2>
                  <strong>Localização</strong> do imóvel
                </h2>
              </div>
            </div>
            <div className={styles.locInner}>
              <h5>{data.titulo}</h5>
              <Markdown>{data?.descricao}</Markdown>

              <div className={styles.unitys}>
                <div>
                  <img src="/icons/mark.svg" width={18} height={24} />
                  <span>{data?.unidade?.nome}</span>
                </div>
                <Markdown>{data?.unidade?.texto}</Markdown>
              </div>
              <a href={data.link} target="_blank" className={styles.link}>
                <span>Traçar rotas</span>
                <div>
                  <img src="/icons/arrow-right-red.svg" width={24} height={14} />
                </div>
              </a>
            </div>
          </div>

          <a className={styles.mapa} href={data.link} target="_blank">
            <div className={styles.mapaImagem}>
              { data.mapa.url &&
                <Image
                  src={data.mapa.url}
                  width={942}
                  height={500}
                  layout="responsive"
                  objectFit="cover"
                />
              }
            </div>
          </a>
        </div>
      </section>
    </>
  );
}
